"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculatePriorityFees = exports.getNewRedeemResult = exports.getMaxLoanValueFromBondOffer = exports.decode = exports.mapProof = exports.getAssetProof = exports.getTreeCanopyDepth = exports.getAsset = exports.findRuleSetPDA = exports.findTokenRecordPda = exports.getRuleset = exports.getMetaplexMetadata = exports.calculatePricesArray = exports.getSumOfOrdersSeries = exports.calculateNextSpotPrice = exports.enumToAnchorEnum = exports.nowInSeconds = exports.getMetaplexMetadataPda = exports.getMetaplexEditionPda = exports.anchorRawBNsAndPubkeysToNumsAndStrings = exports.returnAnchorProgram = void 0;
const common_1 = require("../common");
const constants_1 = require("./constants");
const bonds_1 = require("./idl/bonds");
const types_1 = require("./types");
const mpl_token_metadata_1 = require("@metaplex-foundation/mpl-token-metadata");
const anchor_1 = require("@project-serum/anchor");
const spl_account_compression_1 = require("@solana/spl-account-compression");
const axios_1 = __importDefault(require("axios"));
const bs58 = __importStar(require("bs58"));
const lodash_1 = require("lodash");
const returnAnchorProgram = (programId, connection) => new anchor_1.Program(bonds_1.IDL, programId, new anchor_1.AnchorProvider(connection, (0, common_1.createFakeWallet)(), anchor_1.AnchorProvider.defaultOptions()));
exports.returnAnchorProgram = returnAnchorProgram;
const anchorRawBNsAndPubkeysToNumsAndStrings = (rawAccount) => {
    const copyRawAccount = Object.assign({}, rawAccount);
    const newAccount = parseRawAccount(rawAccount.account);
    return Object.assign(Object.assign({}, newAccount), { publicKey: copyRawAccount.publicKey.toString() });
};
exports.anchorRawBNsAndPubkeysToNumsAndStrings = anchorRawBNsAndPubkeysToNumsAndStrings;
const parseRawAccount = (rawAccount) => {
    const copyRawAccount = Object.assign({}, rawAccount);
    for (const key in copyRawAccount) {
        if (copyRawAccount[key] === null || copyRawAccount[key] === undefined)
            continue;
        if (key === 'roundValue') {
            copyRawAccount[key] = copyRawAccount[key].toString();
            continue;
        }
        if (key === 'creatorHash') {
            copyRawAccount[key] = bs58.encode(copyRawAccount[key]);
            continue;
        }
        if (copyRawAccount[key].toNumber) {
            try {
                copyRawAccount[key] = copyRawAccount[key].toNumber();
            }
            catch (err) {
                copyRawAccount[key] = 0;
            }
        }
        if (copyRawAccount[key].toBase58) {
            copyRawAccount[key] = copyRawAccount[key].toBase58();
        }
        if (typeof copyRawAccount[key] === 'object' && Object.keys(copyRawAccount[key]).length === 1) {
            copyRawAccount[key] = Object.keys(copyRawAccount[key])[0];
        }
        else if (typeof copyRawAccount[key] === 'object') {
            copyRawAccount[key] = parseRawAccount(copyRawAccount[key]);
        }
    }
    return copyRawAccount;
};
const getMetaplexEditionPda = (mintPubkey) => {
    const editionPda = anchor_1.utils.publicKey.findProgramAddressSync([
        Buffer.from(constants_1.METADATA_PREFIX),
        constants_1.METADATA_PROGRAM_PUBKEY.toBuffer(),
        new anchor_1.web3.PublicKey(mintPubkey).toBuffer(),
        Buffer.from(constants_1.EDITION_PREFIX),
    ], constants_1.METADATA_PROGRAM_PUBKEY);
    return editionPda[0];
};
exports.getMetaplexEditionPda = getMetaplexEditionPda;
const getMetaplexMetadataPda = (mintPubkey) => {
    const metaPda = anchor_1.utils.publicKey.findProgramAddressSync([Buffer.from(constants_1.METADATA_PREFIX), constants_1.METADATA_PROGRAM_PUBKEY.toBuffer(), new anchor_1.web3.PublicKey(mintPubkey).toBuffer()], constants_1.METADATA_PROGRAM_PUBKEY);
    return metaPda[0];
};
exports.getMetaplexMetadataPda = getMetaplexMetadataPda;
const nowInSeconds = () => Math.floor((0, lodash_1.now)() / 1000);
exports.nowInSeconds = nowInSeconds;
const enumToAnchorEnum = (anyEnum) => ({ [anyEnum]: {} });
exports.enumToAnchorEnum = enumToAnchorEnum;
const calculateNextSpotPrice = ({ orderType, spotPrice, delta, bondingCurveType, counter, }) => {
    if (bondingCurveType === types_1.BondingCurveType.Linear) {
        let current_price = spotPrice; // 1
        const targetCounter = counter + (orderType === types_1.OrderType.Buy ? 1 : -1);
        if (targetCounter >= 0) {
            // 0
            for (let i = 0; i < Math.abs(targetCounter); i++) {
                current_price += delta;
            }
        }
        else {
            for (let i = 0; i < Math.abs(targetCounter); i++) {
                current_price -= delta;
            }
        }
        return current_price;
    }
    else if (bondingCurveType === types_1.BondingCurveType.Exponential) {
        const newCounter = orderType === types_1.OrderType.Buy ? counter + 1 : counter - 1;
        const newDelta = newCounter > 0 ? (delta + 1e4) / 1e4 : 1 / ((delta + 1e4) / 1e4);
        return spotPrice * Math.pow(newDelta, Math.abs(newCounter));
    }
    return 0;
};
exports.calculateNextSpotPrice = calculateNextSpotPrice;
const getSumOfOrdersSeries = ({ amountOfOrders, orderType, spotPrice, delta, bondingCurveType, counter, }) => {
    let series_sum = 0;
    let currentSpotPrice = (0, exports.calculateNextSpotPrice)({
        orderType,
        spotPrice: spotPrice,
        delta,
        bondingCurveType,
        counter: counter + 1,
    });
    let newCounter = counter;
    for (let i = 0; i < amountOfOrders; i++) {
        series_sum += currentSpotPrice;
        currentSpotPrice = (0, exports.calculateNextSpotPrice)({
            orderType,
            spotPrice: spotPrice,
            delta,
            bondingCurveType,
            counter: newCounter,
        });
        newCounter = orderType === types_1.OrderType.Buy ? newCounter + 1 : newCounter - 1;
    }
    return series_sum;
};
exports.getSumOfOrdersSeries = getSumOfOrdersSeries;
// if quantity_of_orders == 0 {
//   return 0;
// }
// counter = counter.checked_add(1).unwrap();
// let mut starting_spot_price = spot_price; // 1
// let mut next_smallest_buy_order_price = spot_price; //1
// let mut sum: u64 = 0; //1
// for _ in 0..(quantity_of_orders) {
//   next_smallest_buy_order_price = BondingCurve::calculate_next_spot_price(
//       bonding_type,
//       delta,
//       starting_spot_price,
//       false,
//       counter,
//   );
//   sum = sum.checked_add(next_smallest_buy_order_price).unwrap();
//   counter = counter.checked_sub(1).unwrap();
// }
// sum
const calculatePricesArray = ({ starting_spot_price, delta, amount, bondingCurveType, orderType, counter, }) => {
    const array = [];
    let newCounter = orderType === types_1.OrderType.Sell ? counter + 1 : counter;
    for (let i = 0; i < amount; i++) {
        const next_price = (0, exports.calculateNextSpotPrice)({
            orderType,
            delta,
            bondingCurveType,
            spotPrice: starting_spot_price,
            counter: newCounter,
        });
        array.push(next_price);
        newCounter = orderType === types_1.OrderType.Buy ? newCounter + 1 : newCounter - 1;
    }
    const total = array.reduce((acc, price) => acc + price, 0);
    return { array, total };
};
exports.calculatePricesArray = calculatePricesArray;
const getMetaplexMetadata = (mintPubkey) => {
    const [metadata] = anchor_1.web3.PublicKey.findProgramAddressSync([Buffer.from(constants_1.METADATA_PREFIX), constants_1.METADATA_PROGRAM_PUBKEY.toBuffer(), mintPubkey.toBuffer()], constants_1.METADATA_PROGRAM_PUBKEY);
    return metadata;
};
exports.getMetaplexMetadata = getMetaplexMetadata;
const getRuleset = (mintPubkey, connection) => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b;
    try {
        const nftMetadata = (0, exports.getMetaplexMetadata)(new anchor_1.web3.PublicKey(mintPubkey));
        const meta = yield mpl_token_metadata_1.Metadata.fromAccountAddress(connection, nftMetadata);
        return (_b = (_a = meta.programmableConfig) === null || _a === void 0 ? void 0 : _a.ruleSet) !== null && _b !== void 0 ? _b : undefined;
    }
    catch (_c) {
        return undefined;
    }
});
exports.getRuleset = getRuleset;
const findTokenRecordPda = (mint, token) => {
    return anchor_1.web3.PublicKey.findProgramAddressSync([
        Buffer.from(constants_1.METADATA_PREFIX),
        constants_1.METADATA_PROGRAM_PUBKEY.toBuffer(),
        mint.toBuffer(),
        Buffer.from(constants_1.TOKEN_RECORD),
        token.toBuffer(),
    ], constants_1.METADATA_PROGRAM_PUBKEY)[0];
};
exports.findTokenRecordPda = findTokenRecordPda;
const findRuleSetPDA = (payer, name) => {
    return anchor_1.web3.PublicKey.findProgramAddressSync([Buffer.from('rule_set'), payer.toBuffer(), Buffer.from(name)], constants_1.AUTHORIZATION_RULES_PROGRAM)[0];
};
exports.findRuleSetPDA = findRuleSetPDA;
function getAsset(assetId, rpcUrl) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const axiosInstance = axios_1.default.create({
                baseURL: rpcUrl,
            });
            const response = yield axiosInstance.post(rpcUrl, {
                jsonrpc: '2.0',
                method: 'getAsset',
                id: 'rpd-op-123',
                params: {
                    id: assetId,
                },
            });
            return response.data.result;
        }
        catch (error) {
            console.error(error);
        }
    });
}
exports.getAsset = getAsset;
function getTreeCanopyDepth(treeAddress, connection) {
    return __awaiter(this, void 0, void 0, function* () {
        const treeAccount = yield spl_account_compression_1.ConcurrentMerkleTreeAccount.fromAccountAddress(connection, treeAddress);
        const canopyDepth = treeAccount.getCanopyDepth();
        return canopyDepth;
    });
}
exports.getTreeCanopyDepth = getTreeCanopyDepth;
function getAssetProof(assetId, rpcUrl) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const axiosInstance = axios_1.default.create({
                baseURL: rpcUrl,
            });
            const response = yield axiosInstance.post(rpcUrl, {
                jsonrpc: '2.0',
                method: 'getAssetProof',
                id: 'rpd-op-123',
                params: {
                    id: assetId,
                },
            });
            return response.data.result;
        }
        catch (error) {
            console.error(error);
        }
    });
}
exports.getAssetProof = getAssetProof;
const mapProof = (assetProof, canopyDepth) => {
    if (!assetProof.proof || assetProof.proof.length === 0) {
        throw new Error('Proof is empty');
    }
    return assetProof.proof.slice(0, assetProof.proof.length - (!!canopyDepth ? canopyDepth : 0)).map((node) => ({
        pubkey: new anchor_1.web3.PublicKey(node),
        isSigner: false,
        isWritable: false,
    }));
};
exports.mapProof = mapProof;
function decode(stuff) {
    return bufferToArray(bs58.decode(stuff));
}
exports.decode = decode;
function bufferToArray(buffer) {
    const nums = [];
    for (let i = 0; i < buffer.length; i++) {
        nums.push(buffer[i]);
    }
    return nums;
}
const getMaxLoanValueFromBondOffer = (bondOffer) => Math.min((bondOffer.buyOrdersQuantity > 0 ? bondOffer.currentSpotPrice : 0) + bondOffer.bidSettlement, bondOffer.validation.loanToValueFilter);
exports.getMaxLoanValueFromBondOffer = getMaxLoanValueFromBondOffer;
const getNewRedeemResult = (previousRedeemResult, redeemResult) => {
    let newRedeemResult = types_1.RedeemResult.None;
    switch (previousRedeemResult) {
        case types_1.RedeemResult.DirectBorrow:
            switch (redeemResult) {
                case types_1.RedeemResult.DirectRepaid:
                    newRedeemResult = types_1.RedeemResult.DirectBorrowAndDirectRepaid;
                case types_1.RedeemResult.Reborrow:
                    newRedeemResult = types_1.RedeemResult.DirectBorrowAndReborrowRepaid;
                case types_1.RedeemResult.InstantRefinanced:
                    newRedeemResult = types_1.RedeemResult.DirectBorrowAndInstantRefinancedRepaid;
                case types_1.RedeemResult.RefinancedByAuction:
                    newRedeemResult = types_1.RedeemResult.DirectBorrowAndRefinancedByAuctionRepaid;
                case types_1.RedeemResult.PartialRepay:
                    newRedeemResult = types_1.RedeemResult.DirectBorrowAndPartialRepaid;
                case types_1.RedeemResult.Claimed:
                    newRedeemResult = types_1.RedeemResult.DirectBorrowAndClaimed;
            }
        case types_1.RedeemResult.Reborrow:
            switch (redeemResult) {
                case types_1.RedeemResult.DirectRepaid:
                    newRedeemResult = types_1.RedeemResult.ReborrowAndDirectRepaid;
                case types_1.RedeemResult.Reborrow:
                    newRedeemResult = types_1.RedeemResult.ReborrowAndReborrowRepaid;
                case types_1.RedeemResult.InstantRefinanced:
                    newRedeemResult = types_1.RedeemResult.ReborrowAndInstantRefinancedRepaid;
                case types_1.RedeemResult.RefinancedByAuction:
                    newRedeemResult = types_1.RedeemResult.ReborrowAndRefinancedByAuctionRepaid;
                case types_1.RedeemResult.PartialRepay:
                    newRedeemResult = types_1.RedeemResult.ReborrowAndPartialRepaid;
                case types_1.RedeemResult.Claimed:
                    newRedeemResult = types_1.RedeemResult.ReborrowAndClaimed;
            }
        case types_1.RedeemResult.InstantRefinanced:
            switch (redeemResult) {
                case types_1.RedeemResult.DirectRepaid:
                    newRedeemResult = types_1.RedeemResult.InstantRefinancedAndDirectRepaid;
                case types_1.RedeemResult.Reborrow:
                    newRedeemResult = types_1.RedeemResult.InstantRefinancedAndReborrowRepaid;
                case types_1.RedeemResult.InstantRefinanced:
                    newRedeemResult = types_1.RedeemResult.InstantRefinancedAndInstantRefinancedRepaid;
                case types_1.RedeemResult.RefinancedByAuction:
                    newRedeemResult = types_1.RedeemResult.InstantRefinancedAndRefinancedByAuctionRepaid;
                case types_1.RedeemResult.PartialRepay:
                    newRedeemResult = types_1.RedeemResult.InstantRefinancedAndPartialRepaid;
                case types_1.RedeemResult.Claimed:
                    newRedeemResult = types_1.RedeemResult.InstantRefinancedAndClaimed;
            }
        case types_1.RedeemResult.RefinancedByAuction:
            switch (redeemResult) {
                case types_1.RedeemResult.DirectRepaid:
                    newRedeemResult = types_1.RedeemResult.RefinancedByAuctionAndDirectRepaid;
                case types_1.RedeemResult.Reborrow:
                    newRedeemResult = types_1.RedeemResult.RefinancedByAuctionAndReborrowRepaid;
                case types_1.RedeemResult.InstantRefinanced:
                    newRedeemResult = types_1.RedeemResult.RefinancedByAuctionAndInstantRefinancedRepaid;
                case types_1.RedeemResult.RefinancedByAuction:
                    newRedeemResult = types_1.RedeemResult.RefinancedByAuctionAndRefinancedByAuctionRepaid;
                case types_1.RedeemResult.PartialRepay:
                    newRedeemResult = types_1.RedeemResult.RefinancedByAuctionAndPartialRepaid;
                case types_1.RedeemResult.Claimed:
                    newRedeemResult = types_1.RedeemResult.RefinancedByAuctionAndClaimed;
            }
        case types_1.RedeemResult.PartialRepay:
            switch (redeemResult) {
                case types_1.RedeemResult.DirectRepaid:
                    newRedeemResult = types_1.RedeemResult.PartialRepaidAndDirectRepaid;
                case types_1.RedeemResult.Reborrow:
                    newRedeemResult = types_1.RedeemResult.PartialRepaidAndReborrowRepaid;
                case types_1.RedeemResult.InstantRefinanced:
                    newRedeemResult = types_1.RedeemResult.PartialRepaidAndInstantRefinancedRepaid;
                case types_1.RedeemResult.RefinancedByAuction:
                    newRedeemResult = types_1.RedeemResult.PartialRepaidAndRefinancedByAuctionRepaid;
                case types_1.RedeemResult.PartialRepay:
                    newRedeemResult = types_1.RedeemResult.PartialRepaidAndPartialRepaid;
                case types_1.RedeemResult.Claimed:
                    newRedeemResult = types_1.RedeemResult.PartialRepaidAndClaimed;
            }
        case types_1.RedeemResult.None:
            switch (redeemResult) {
                case types_1.RedeemResult.DirectRepaid:
                    newRedeemResult = types_1.RedeemResult.DirectRepaid;
                case types_1.RedeemResult.Reborrow:
                    newRedeemResult = types_1.RedeemResult.Reborrow;
                case types_1.RedeemResult.InstantRefinanced:
                    newRedeemResult = types_1.RedeemResult.InstantRefinanced;
                case types_1.RedeemResult.RefinancedByAuction:
                    newRedeemResult = types_1.RedeemResult.RefinancedByAuction;
                case types_1.RedeemResult.PartialRepay:
                    newRedeemResult = types_1.RedeemResult.PartialRepay;
                case types_1.RedeemResult.Claimed:
                    newRedeemResult = types_1.RedeemResult.Claimed;
            }
    }
    return newRedeemResult;
};
exports.getNewRedeemResult = getNewRedeemResult;
const fetch = require('node-fetch');
const calculatePriorityFees = (connection) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const response = yield fetch(connection.rpcEndpoint, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                jsonrpc: '2.0',
                id: 'my-id',
                method: 'getPriorityFeeEstimate',
                "params": [{
                        "accountKeys": [constants_1.BONDS_PROGRAM_PUBKEY],
                        "options": {
                            "includeAllPriorityFeeLevels": true
                        }
                    }],
            }),
        });
        const { result } = yield response.json();
        console.log(result);
        return result.priorityFeeLevels.veryHigh;
    }
    catch (_d) {
        return constants_1.BASE_PRIORITY_FEES;
    }
});
exports.calculatePriorityFees = calculatePriorityFees;
